import responsiveImageMap from './responsive-image-map.js'

module.exports = responsiveImageMap
